export const MessageConst = {

    Inv_Site_Del: 'Site deleted successfully',
    Inv_Site_Create: "Site created successfully",
    Inv_Site_Update: 'Site updated successfully',
    Inv_Site_Validate_Site_Req: 'Please enter Site Name',
    Inv_Site_Validate_School_Req_Select: 'Please Select School',
    Inv_Validate_Name: 'please enter Name',
    Inv_Validate_Vendor: 'please select vendor',
    Inv_Validate_Desc: 'please enter description',
    Inv_Validate_ProdCode: 'please enter product code',
    Inv_Validate_unit: 'Please select switch unit',
    Inv_Validate_itemsPerCase: 'please enter items per case',
    Inv_Validate_itemUnit: 'please select item unit',
    Inv_Validate_itemWeight: 'please enter item weight',
    Inv_Validate_weightUnit: 'please enter item weight unit',
    Inv_Validate_StorageLocation: 'please select storage location',

    Rec_Validate_RecName: 'Please fill recipe name',
    Rec_Validate_RecMenu_Name: 'Please fill the menu name',
    Rec_Validate_RecType: 'Please select recipe type',
    Rec_Validate_RecSubType: 'Please select recipe SubType',
    Rec_Validate_RecCategory: 'Please select recipe category',
    Rec_Validate_ServPorSize: 'Please enter serving portion size',
    Rec_Validate_ServPorType: 'Please enter serving portion type',
    Rec_Validate_ServSize_Weight: 'Please enter Serving size and weight',
    Rec_Validate_QuantServ: 'Please enter quantity of servings',
    Rec_Validate_CreditInfo: 'Please add atleast one crediting information',
    Rec_Validate_CreditInfo_Select_Item: 'Please provide crediting information values for selected items',
    Rec_Validate_Ingr_Info: 'Please add atleast one ingredient information',
    Rec_Validate_All_Select_Ingr: 'Please provide all required values for selected ingredients.',
    Rec_Validate_Sub_CatName: 'Please enter sub category name',
    Rec_Sub_Cat_Success: 'Subcategory added successfully',
    Rec_Sub_Cat_Error: 'Sub category name already exits.',
    Rec_Ingr_Validate_Weight_measure: 'Please select weight & measure',
    Rec_Ingr_Validate_Name: 'Please provide ingredient name',
    ReC_Ingr_Validate_Desc: 'Please provide ingredient description',

    Ingr_Del: 'Deleted successfully.',
    Ingr_Validate_weight_Mesr: 'Please select weight & measure',
    Ingr_Validate_Name: 'Please provide name',
    Ingr_Validate_Desc: 'Please enter description',
    Ingr_Validate_ProdCode: 'Please provide product code',
    Ingr_Update: 'Data saved successfully',
    //Ingr_Validate_Rec_Cat:'Please fill the recipe category',
    Ingr_Validate_All_Data: 'Please select all deails',
    Ingr_Validate_For_Rec: 'Please select ingredients for replace',

    Mast_Archive_Rec: 'Record archived successfully',
    Mast_Restore_Rec: 'Record restore successfully',
    Mast_Create_Rec: 'Records saved successfully',
    Mast_Validate_Cat: 'Please select Category',
    Mast_Validate_Name: 'Please select Name',
    Mast_Validate_SubCat: 'Please select subcategory',
    Mast_Item_update: 'Menu item updated successfully.',
    Mast_Item_Create_Menu: 'Successfully Created Menu Item.',
    Mast_Item_Error: 'Something went wrong, Please check again...!',

    Menu_Analys_Validate_ProgType: 'Please select program type',
    Menu_Analys_Validate_Grade: 'Please select grade',
    Menu_Analys_Validate_Items: 'Please select items',
    Menu_Analys_Validate_Menu_Items: 'Please add menu items',
    Menu_Analys_Validate_Menu_Name: 'Please enter menu name',
    Menu_Analys_Error: 'Something went wrong. please contact administrator',

    Roll_Menu_Temp_Validate_Weeks: 'no.of weeks should be more than 0',
    Roll_Menu_Temp_Validate_Name: 'Please enter template name',
    Roll_Menu_Temp_Update: 'Rolling template updated successfully',
    Roll_Menu_Temp_Create: 'Rolling template created successfully',
    Roll_Menu_Temp_Error: 'Something went wrong, PLease try again later.',

    School_Menu_Suc: 'Menu unpublished successfully',
    School_Menu_Unpub_Error: 'failed to unpublish menu, Order cannot be cancel for current/past date.',
    School_Menu_Error: 'Sorry, Something went wrong. Please try again later.',

    Prod_Menu_Validate_For_Planned: 'Please enter atleast one order for planned',

    Inv_List_Site_Validate_Stock: 'Please add stock details for atleast one item.',
    Inv_List_Site_Validate_All_Stock: 'Please provide all stock details for selected items.',

    Meal_Order_Error: 'Orders not available for today.',

    Manage_User_validate_FName: 'Please provide first name',
    Manage_User_validate_LName: 'Please provide last name',
    Manage_User_validate_MobileNo: 'Please provide mobile no',
    Manage_User_validate_Login_UserName: 'Please provide login user name',

    Nutrion_Anly_Validate_School: 'Please select school',
    Nutrion_Anly_Validate_menuType: 'Please select menu type',
    Nutrion_Anly_Validate_progType: 'Please select program type',
    Nutrion_Anly_Validate_Grade_Age: 'Please select grades/age group',

    MasterMenu_Anly_Save: 'Records saved successfully',
    MasterMenu_Anly_Update: 'Records saved successfully',

    Meal_Patt_Report_Validate_School: 'Please select school',
    Meal_Patt_Report_Validate_menuType: 'Please select menu type',
    Meal_Patt_Report_Validate_progType: 'Please select program type',
    Meal_Patt_Report_Validate_Grade_Age: 'Please select grades/age group',

    Inv_Purchase_Order_Report_Select_Error: "Please select items",
    Default_Error: "Something went wrong. Please try again later.",

    Transfer_Report_Validate_Site: 'Please select site',
    Transfer_Report_Validate_OrderType: 'Please select Order Type',

    Physical_Summary_Report_Validate_Site: 'Please select site',

    Inv_Purchase_Order_Report_Select_Date: 'Please select date',
    Inv_Purchase_Order_Report_Select_Site: 'Please select site',
    Inv_Purchase_Order_Report_Select_Vendor: 'Please select vendor',












}